import { render, staticRenderFns } from "./edit-template-popup.vue?vue&type=template&id=27fe5dc8"
import script from "./edit-template-popup.vue?vue&type=script&lang=js"
export * from "./edit-template-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports